import PageTitle from "components/headers/PageTitle";
import StepLine from "components/step-line";
import React from "react";
import { useTranslation } from "react-i18next";

const StepPointAccrual = (props) => {
  const { setModalLogin, setShowQrCodeConfirmPayment } = props;
  const { t } = useTranslation("translation");
  return (
    <>
      <PageTitle
        title={t("checkoutOrderTitle")}
        onClickLeftIcon={() => {
            setModalLogin(false)
            setShowQrCodeConfirmPayment(true)
        }}
      />
      <StepLine activeStep={2}/>
    </>
  );
};

export default StepPointAccrual;
